const serviceLinks = [
  'BPC/LOAS',
  'Aposentadoria',
  'Auxílio-Doença',
  'Auxílio-Maternidade',
  'Auxílio-Acidente',
  'Aposentadoria Rural',
];

export default function Footer() {
  return (
    <footer className="bg-brand-dark">
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-8 pt-16 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">

          {/* Column 1: Brand */}
          <div className="md:col-span-2">
            <img
              src="https://cloud-1de12d.becdn.net/media/original/d9cb7c1a38d700abdcef0c923bf7c2e0/lgo-2.png"
              alt="Ariani Zanardo Advocacia"
              className="h-9 w-auto object-contain mb-5 brightness-0 invert"
            />
            <p className="font-inter text-sm text-white/40 leading-relaxed max-w-xs mb-6">
              Especialista em Direito Previdenciário. Atendimento humanizado, técnico e remoto para todo o Brasil.
            </p>
            <a
              href="https://api.whatsapp.com/send?phone=5551996057679&text=Ol%C3%A1,%20vim%20do%20seu%20site%20e%20gostaria%20de%20falar%20com%20um%20advogado."
              target="_blank"
              rel="noopener noreferrer"
              className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 bg-white/8 hover:bg-white/12 text-white/70 hover:text-white font-inter text-xs px-4 py-2.5 rounded-md transition-all duration-200"
            >
              <i className="ri-whatsapp-line text-sm text-brand-gold-pale" />
              (51) 99605-7679
            </a>
          </div>

          {/* Column 2: Services */}
          <div>
            <p className="font-inter text-xs font-medium text-white/30 uppercase tracking-[0.15em] mb-5">
              Serviços
            </p>
            <ul className="flex flex-col gap-2.5">
              {serviceLinks.map((s) => (
                <li key={s}>
                  <a
                    href="#servicos"
                    className="font-inter text-sm text-white/50 hover:text-white/80 transition-colors duration-200 cursor-pointer"
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector('#servicos')?.scrollIntoView({ behavior: 'smooth' });
                    }}
                  >
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Legal & Contato */}
          <div>
            <p className="font-inter text-xs font-medium text-white/30 uppercase tracking-[0.15em] mb-5">
              Legal
            </p>
            <ul className="flex flex-col gap-2.5 mb-8">
              {['Política de Privacidade', 'Política de Cookies'].map((l) => (
                <li key={l}>
                  <a href="#" className="font-inter text-sm text-white/50 hover:text-white/80 transition-colors duration-200 cursor-pointer">
                    {l}
                  </a>
                </li>
              ))}
            </ul>
            <p className="font-inter text-xs font-medium text-white/30 uppercase tracking-[0.15em] mb-4">
              Atendimento
            </p>
            <p className="font-inter text-xs text-white/40 leading-relaxed">
              Segunda a Sexta
              <br />
              9h às 18h (horário de Brasília)
            </p>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/8 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-inter text-xs text-white/25">
            © {new Date().getFullYear()} Ariani Zanardo Advocacia. Todos os direitos reservados.
          </p>
          <p className="font-inter text-xs text-white/20">
            OAB — Direito Previdenciário
          </p>
        </div>
      </div>
    </footer>
  );
}
